import type { UserPreferences, UserProfile } from '@smart-home/shared';
import { api } from './client';

export async function getCurrentUser() {
  const res = await api.get<UserProfile>('/user/me');
  return res.data;
}

export async function updateUserPreferences(payload: Partial<UserPreferences>) {
  const res = await api.put<UserProfile>('/user/preferences', payload);
  return res.data;
}
